// Subtle logo overlay used to watermark photos across the site.
// Placement: bottom-right corner of an absolutely-positioned image container.
export const Watermark = ({ size = 'md', position = 'br', className = '' }) => {
    const sizeMap = {
        sm: 'w-10 md:w-12',
        md: 'w-14 md:w-20',
        lg: 'w-20 md:w-28',
    };
    const posMap = {
        br: 'bottom-3 right-3 md:bottom-4 md:right-4',
        bl: 'bottom-3 left-3 md:bottom-4 md:left-4',
        tr: 'top-3 right-3 md:top-4 md:right-4',
        tl: 'top-3 left-3 md:top-4 md:left-4',
    };
    return (
        <img
            src="/logo-watermark.png"
            alt=""
            aria-hidden
            loading="lazy"
            className={`absolute ${posMap[position] || posMap.br} ${sizeMap[size] || sizeMap.md} opacity-70 drop-shadow-[0_2px_6px_rgba(0,0,0,0.35)] pointer-events-none select-none z-10 ${className}`}
        />
    );
};
